export default __webpack_public_path__ + "static/media/download-solid-white.dd7ec20f.svg";